import { CommitmentSourcesSimulateSensitiveService_commitmentSourcesSensitiveSimulateServicePostSimulation } from '@festina/life-general-types/life/hooks/CommitmentSourcesSimulateSensitiveService_commitmentSourcesSensitiveSimulateServicePostSimulation'

export const useFetchCommitmentVersionSensitiveSimulated =
  CommitmentSourcesSimulateSensitiveService_commitmentSourcesSensitiveSimulateServicePostSimulation.useSuspenseQuery
